import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/chat/update-icon.svg'
import _imports_1 from '@/components/nav/component/img/message_arrow.svg'
import _imports_2 from '@/assets/location/locationInfo-active.svg'
import _imports_3 from '@/assets/location/locationInfo-default.svg'
import _imports_4 from '@/assets/location/virtual.svg'
import _imports_5 from '../../assets/chat/empty-img-default.svg'
import _imports_6 from './img/threeDots.svg'
import _imports_7 from './img/unbinding.svg'
import _imports_8 from './img/iosArrow.svg'
import _imports_9 from './img/message-gou.svg'
import _imports_10 from './img/iphoneModel.svg'
import _imports_11 from '@/assets/ios/online.svg'
import _imports_12 from '@/assets/ios/offline.svg'
import _imports_13 from './img/up-arrow.svg'
import _imports_14 from './img/down-arrow.svg'
import _imports_15 from './img/dashIns.png'
import _imports_16 from './img/dashWhatsapp.png'
import _imports_17 from './img/picture.svg'
import _imports_18 from './img/load.png'


const _hoisted_1 = { class: "homePage" }
const _hoisted_2 = { class: "btnText" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "updateIcon",
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "btnText" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "updateIcon",
  alt: ""
}, null, -1)
const _hoisted_6 = { class: "btnText" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "updateIcon",
  alt: ""
}, null, -1)
const _hoisted_8 = { class: "btnText" }
const _hoisted_9 = {
  key: 4,
  class: "homeWhatsnew"
}
const _hoisted_10 = { class: "homeSkeleton" }
const _hoisted_11 = { class: "homeSkeletonItemWrapper" }
const _hoisted_12 = { class: "skTop" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "info" }
const _hoisted_15 = { class: "leftIcon" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "newly" }
const _hoisted_20 = {
  key: 0,
  class: "symbol-add"
}
const _hoisted_21 = {
  key: 1,
  class: "symbol-sub"
}
const _hoisted_22 = { class: "total" }
const _hoisted_23 = { class: "showDash" }
const _hoisted_24 = {
  key: 0,
  class: "dashContent iosContent",
  id: "iosContent"
}
const _hoisted_25 = {
  key: 0,
  class: "geoLocationPublic iosGeolocation"
}
const _hoisted_26 = { class: "homeTheader" }
const _hoisted_27 = {
  key: 0,
  class: "setMinHeight"
}
const _hoisted_28 = { class: "leftMaps" }
const _hoisted_29 = { class: "rightInfo" }
const _hoisted_30 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "localImg"
}
const _hoisted_31 = {
  key: 1,
  src: _imports_3,
  alt: "",
  class: "localImg"
}
const _hoisted_32 = { class: "itemInfo" }
const _hoisted_33 = { class: "infoDetail" }
const _hoisted_34 = { class: "info" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 1,
  class: "homeEmpty homeIosEmpty"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1)
const _hoisted_40 = { class: "empty-text" }
const _hoisted_41 = {
  key: 1,
  class: "geoLoading geoLocationPublic iosGeolocation"
}
const _hoisted_42 = { class: "iosAccountBox" }
const _hoisted_43 = { class: "bheader" }
const _hoisted_44 = { class: "homeOverflow" }
const _hoisted_45 = {
  class: "flexSpaceBetween",
  style: {"margin-top":"16px","height":"16px","padding":"15px 20px"}
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "unbindImg"
}, null, -1)
const _hoisted_47 = { class: "unbindText" }
const _hoisted_48 = {
  key: 0,
  class: "model"
}
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  key: 0,
  class: "iosList"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "info" }
const _hoisted_53 = { class: "topInfo" }
const _hoisted_54 = { class: "bottomInfo" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  class: "model",
  alt: "",
  src: _imports_10
}, null, -1)
const _hoisted_56 = { class: "deviceModel homeOverflow" }
const _hoisted_57 = {
  key: 0,
  class: "dots",
  src: _imports_11,
  alt: ""
}
const _hoisted_58 = {
  key: 1,
  class: "dots",
  src: _imports_12,
  alt: ""
}
const _hoisted_59 = {
  key: 1,
  class: "model"
}
const _hoisted_60 = { class: "noIosLis" }
const _hoisted_61 = { class: "wrap" }
const _hoisted_62 = { class: "left" }
const _hoisted_63 = { class: "background" }
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "content" }
const _hoisted_66 = { class: "text" }
const _hoisted_67 = {
  key: 0,
  class: "content"
}
const _hoisted_68 = {
  key: 1,
  class: "content"
}
const _hoisted_69 = {
  key: 2,
  class: "content"
}
const _hoisted_70 = { class: "syncText" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "iosWhite" }, null, -1)
const _hoisted_72 = {
  class: "bheader",
  style: {"padding-bottom":"20px"}
}
const _hoisted_73 = {
  class: "flexSpaceBetween",
  style: {"margin-top":"16px","height":"16px","padding":"15px 20px"}
}
const _hoisted_74 = { style: {"padding-top":"16px"} }
const _hoisted_75 = ["src"]
const _hoisted_76 = {
  key: 0,
  class: "content"
}
const _hoisted_77 = {
  key: 1,
  class: "content"
}
const _hoisted_78 = {
  key: 0,
  class: "content"
}
const _hoisted_79 = {
  key: 1,
  class: "content"
}
const _hoisted_80 = { class: "renewText" }
const _hoisted_81 = {
  key: 1,
  class: "dashContent"
}
const _hoisted_82 = {
  key: 0,
  class: "geoLocationPublic geolocation"
}
const _hoisted_83 = { class: "homeTheader" }
const _hoisted_84 = {
  key: 0,
  class: "setMinHeight"
}
const _hoisted_85 = { class: "rightInfo" }
const _hoisted_86 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "localImg"
}
const _hoisted_87 = {
  key: 1,
  src: _imports_3,
  alt: "",
  class: "localImg"
}
const _hoisted_88 = { class: "itemInfo" }
const _hoisted_89 = { class: "infoDetail" }
const _hoisted_90 = { class: "info" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = {
  key: 1,
  class: "homeEmpty"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1)
const _hoisted_96 = { class: "empty-text" }
const _hoisted_97 = {
  key: 1,
  class: "geolocation geoLoading"
}
const _hoisted_98 = { class: "homeSkeleton" }
const _hoisted_99 = { class: "homeSkeletonItemWrapper" }
const _hoisted_100 = { class: "skTop" }
const _hoisted_101 = { class: "homeSkeleton" }
const _hoisted_102 = { class: "homeSkeletonItemWrapper" }
const _hoisted_103 = { class: "skTop" }
const _hoisted_104 = { class: "average" }
const _hoisted_105 = {
  key: 0,
  class: "avarageWrap"
}
const _hoisted_106 = { class: "avarageItem" }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { class: "range" }
const _hoisted_110 = { class: "daliy" }
const _hoisted_111 = { class: "float" }
const _hoisted_112 = {
  key: 0,
  src: _imports_13,
  class: "arrow"
}
const _hoisted_113 = {
  key: 1,
  src: _imports_14,
  class: "arrow"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", {
  id: "chartContainer",
  style: {"width":"320px","height":"300px"}
}, null, -1)
const _hoisted_115 = {
  key: 1,
  class: "homeEmpty"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1)
const _hoisted_117 = { class: "empty-text" }
const _hoisted_118 = { class: "mostUse" }
const _hoisted_119 = { class: "title" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = {
  key: 1,
  class: "homeEmpty"
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1)
const _hoisted_124 = { class: "empty-text" }
const _hoisted_125 = { key: 1 }
const _hoisted_126 = {
  class: "homeSkeleton",
  style: {"height":"72px","padding":"0"}
}
const _hoisted_127 = { class: "homeSkeletonItemWrapper" }
const _hoisted_128 = { class: "skTop" }
const _hoisted_129 = { class: "insIcon" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  class: "icon"
}, null, -1)
const _hoisted_131 = { class: "title" }
const _hoisted_132 = { class: "homeTheader" }
const _hoisted_133 = { class: "homeSkeleton" }
const _hoisted_134 = { class: "homeSkeletonItemWrapper" }
const _hoisted_135 = { class: "skTop" }
const _hoisted_136 = {
  key: 0,
  class: "setMinHeight"
}
const _hoisted_137 = {
  key: 1,
  class: "homeEmpty"
}
const _hoisted_138 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1)
const _hoisted_139 = { class: "empty-text" }
const _hoisted_140 = { class: "appIcon" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  class: "icon"
}, null, -1)
const _hoisted_142 = { class: "title" }
const _hoisted_143 = { class: "homeTheader" }
const _hoisted_144 = { class: "homeSkeleton" }
const _hoisted_145 = { class: "homeSkeletonItemWrapper" }
const _hoisted_146 = { class: "skTop" }
const _hoisted_147 = {
  key: 0,
  class: "setMinHeight"
}
const _hoisted_148 = {
  key: 1,
  class: "homeEmpty"
}
const _hoisted_149 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1)
const _hoisted_150 = { class: "empty-text" }
const _hoisted_151 = { class: "bheader" }
const _hoisted_152 = { class: "homeOverflow" }
const _hoisted_153 = {
  class: "flexSpaceBetween",
  style: {"margin-top":"16px","height":"16px","padding":"15px 20px"}
}
const _hoisted_154 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "unbindImg"
}, null, -1)
const _hoisted_155 = { class: "unbindText" }
const _hoisted_156 = { class: "model" }
const _hoisted_157 = ["src"]
const _hoisted_158 = {
  key: 0,
  class: "iosList"
}
const _hoisted_159 = ["onClick"]
const _hoisted_160 = { class: "info" }
const _hoisted_161 = { class: "topInfo" }
const _hoisted_162 = { class: "bottomInfo" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("img", {
  class: "model",
  alt: "",
  src: _imports_10
}, null, -1)
const _hoisted_164 = { class: "deviceModel homeOverflow" }
const _hoisted_165 = { class: "wrap" }
const _hoisted_166 = { class: "left" }
const _hoisted_167 = { class: "background" }
const _hoisted_168 = ["src"]
const _hoisted_169 = { class: "content" }
const _hoisted_170 = { class: "text" }
const _hoisted_171 = {
  key: 0,
  class: "content"
}
const _hoisted_172 = {
  key: 1,
  class: "content"
}
const _hoisted_173 = {
  key: 2,
  class: "content"
}
const _hoisted_174 = { class: "syncText" }
const _hoisted_175 = {
  class: "bheader",
  style: {"padding-bottom":"20px"}
}
const _hoisted_176 = {
  class: "flexSpaceBetween",
  style: {"margin-top":"16px","height":"16px","padding":"15px 20px"}
}
const _hoisted_177 = { style: {"padding-top":"16px"} }
const _hoisted_178 = ["src"]
const _hoisted_179 = {
  key: 0,
  class: "content"
}
const _hoisted_180 = {
  key: 1,
  class: "content"
}
const _hoisted_181 = {
  key: 0,
  class: "content"
}
const _hoisted_182 = {
  key: 1,
  class: "content"
}
const _hoisted_183 = { class: "renewText" }
const _hoisted_184 = {
  key: 5,
  class: "homePhotos"
}
const _hoisted_185 = { class: "homeTheader" }
const _hoisted_186 = { class: "content" }
const _hoisted_187 = { class: "showPhoto" }
const _hoisted_188 = ["src"]
const _hoisted_189 = {
  key: 0,
  class: "itemPhoto"
}
const _hoisted_190 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  alt: ""
}, null, -1)
const _hoisted_191 = [
  _hoisted_190
]
const _hoisted_192 = { class: "algin" }
const _hoisted_193 = { class: "percent" }
const _hoisted_194 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  class: "motionImg"
}, null, -1)

import { computed, watch, ref, Ref, onMounted, onUnmounted, } from "vue";
import { getDashBoard, reboundDevice, getDashNew, getDashCount, getLocationApi } from "@/api/devices";
// import { getLocationApi } from "@/api/map";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { dateFormat, dateFormatAm } from "@/utils/format";
import numberItem from "./tabItem/numberItem.vue";
import appItem from "./tabItem/appItem.vue";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { gaEvent } from "@/utils/format";
import { unbindAndEmptyDataApi, photoInfo, syncIOSPhotosApi, iosPhotosApi } from "@/api/devices";
import { unbindIcloud, icloudRebound } from "@/api/ios/index";
import noticeDialog from "./tabItem/noticeDialog.vue";
import messageToast from "@/components/common/messageToast.vue";
import Tooltip from "@/components/common/tooltip.vue";
import { refreshTab } from "@/utils/refresh";
import * as echarts from 'echarts';
import { convertSecondsToHoursMinutes, convertSecondsToHoursMinutesSecond } from "@/views/screen/component/fomat";
import mapBox from '@/components/mapbox/map.vue'
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { getAddressInfo } from "@/utils/mapFun";
import loadingChat from "@/components/chat/loading.vue";
import './css/index.scss';
import emitter from "@/utils/eventBus";

// @ts-ignore
import iphone from '@/assets/ios/big_phone.png';
// @ts-ignore
import Launcher from './img/launcher.svg';
import { jsonDataActive, jsonDataGeneral, jsonDataScreen } from '@/mock/homePage.js'
import { jsonDataLocation, jsonDataLocation2, jsonDataLocation3, jsonDataLocation4 } from '@/mock/locations.js'
import { jsonDataIos } from '@/mock/photos.js'


interface PhotoItem {
  // 根据实际情况定义 PhotoItem 的属性
  date: string;
  // ... 其他属性
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const store = useStore();
let router = useRouter();
const loading = ref(true);// loading 控制骨架屏的显示
const isShowMore750 = computed(() => store.state.isShowMore750);
const messageToastType = computed(() => store.state.messageToastType);
const beExpired = computed(() => store.state.beExpired);
const isExpired = computed(() => store.state.isExpired);
const isVibe = computed(() => !store.state.isVibe);
//地图样式对象
const mapStyleObj = ref({
  'border-radius': '4px'
})
const currDashNewLoading = ref(true)
const deviceType = computed(() => store.state.deviceType)
let homePageFive: any
// 设置新的定时器
function setNewInterval() {
  {
    console.log('setNewInterval', deviceType.value);
    homePageFive = setInterval(function () {
      console.log("newDeviceType.value:", newDeviceType.value, typeof (newDeviceType.value), homePageFive, store.state.deviceType);
      // 直接取store，避免闭包产生的影响
      if (store.state.deviceType === 1 || store.state.defaultMenu == 'guide') {
        console.log('hello!');
        clearInterval(homePageFive)
        homePageFive = null
        return
      }
      console.log('setNewInterval getCurrentDeviceInfo');
      // store.commit('setDeviceType', 0);
      store.dispatch("getCurrentDeviceInfo");
      getCurrentDashBoard();
      getCurrDashNew()
      getScreenCount()
      getGeofencFun()
      console.log('重新设置定时器');
    }, 1000 * 60 * 5);
    console.log('homePageFive', homePageFive);
  }
}

const userAgent = navigator.userAgent;
const originUrl = ref(1)
watch([beExpired], () => {
  gaEvent("Notice_7day", {
    event_category: "Dashboard_Function",
    event_label: "None",
  });
});
watch([isExpired], () => {
  gaEvent("Notice_Expired", {
    event_category: "Dashboard_Function",
    event_label: "None",
  });
});

const lang = computed(() => store.state.currentLang);

const deviceInfo = computed(() => {
  return store.state.deviceInfo;
});

const watchIdFun = async () => {
  console.log("watch id", deviceType.value);
  // requestCount.value = 0
  if (!window.location.href.includes("guide")) {
    loading.value = true;
    currDashNewLoading.value = true
    setTimeout(() => {
      loading.value = false;
    }, 1000);
  }
  if (deviceType.value) {
    if (defaultMenu.value !== 'iosLogin') {
      showLocationLoading.value = true
      showUseTimeLoading.value = true
      mostUseLoading.value = true
      await store.dispatch("getDeviceInfo")
      console.log('test if', homePageFive);
      clearInterval(homePageFive);
      homePageFive = null
      // if (!isVibe.value) {
      console.log('onMounted----ios', deviceType.value);
      // }
      await store.dispatch("getCurrentIcloudInfo")
      if (isVibe.value) {
        demoFun()
      } else {
        await getGeofencFun()
        await getPhotoList()

      }
      console.log('showRebound.value', !showRebound.value);
      if (showRebound.value) {
        store.commit('setMessageToastType', 3);
      }
    }
  } else {
    console.log('test else', homePageFive);
    clearInterval(homePageFive);
    homePageFive = null
    console.log('watch getCurrentDeviceInfo');

    await store.dispatch("getCurrentDeviceInfo");
    appUseList.value = []
    locationsList.value = []


    if (!isVibe.value) {
      console.log('onMounted---- android', deviceType.value);
      if (deviceType.value === 0) {
        console.log("设置了定时任务？？？1111");
        setNewInterval()
      }
      await getCurrentDashBoard();
      await getCurrDashNew()
      await getScreenCount()
      await getGeofencFun()
    } else {
      demoFun()
    }
    gaEvent("Dashboard_PV", {
      event_category: "Dashboard_Function",
      event_label: "None",
    });
    const location = (locationsList.value as any)?.length > 0 ? "Data" : "NoData";
    const average = daliyTime.value ? "Data" : "NoData";
    const ins_call = (ins_session.value as any)?.length > 0 ? "Data" : "NoData";
    const whatsapp_call = (active_session.value as any)?.length > 0 ? "Data" : "NoData";
    const str = location + "_" + average + "_" + whatsapp_call + "_" + ins_call;
    gaEvent("Dashboard_Data", {
      event_category: "Dashboard_Function",
      event_label: str,
    });
  }

  emitter.emit("getExpired");
}

const devicedId = computed(() => {
  console.log('bbbbb111')
  console.log('bbbbb', devicedId)
  return store.state.currentDeviceId;
});

// 自动续费
const autoRenew = computed(() => {
  return store.state.autoRenew;
});


const currentDeviceId = computed(() => store.state.currentDeviceInfo.id);
const currentDevice = computed(() => store.state.currentDeviceInfo.name);
const currentDeviceModel = computed(
  () => store.state.currentDeviceInfo.model
);
const isActive = computed(() => store.state.currentDeviceInfo.is_active);
const isDemo = computed(() => store.state.isDemo);
const defaultMenu = computed(() => store.state.defaultMenu);

let account = ref<any[]>([]);
// 因为不能直接给一个ref为对象的变量直接赋值，所以要给一个泛型，来表明它接收的对象
let bindDevice = computed(() => store.state.boundedDevice)
// android设备展示的内容
let targetDevice = ref<any[]>([]);
// ios设备展示的内容
let iosDevice = ref<any[]>([]);
// whatsapp模块
let active_calls = ref({});
let active_session = ref({});
// instagram模块
let ins_calls = ref({});
let ins_session = ref({});

const syncLoading = computed(() => (store.state as any).headerStore.syncLoading)

// 点击同步按钮触发
const handleUpdateClick = async () => {
  gaEvent("Sync", {
    event_category: "Dashboard_Function",
    event_label: "None",
  });
  if (isVibe.value) {
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  } else {
    showLocationLoading.value = true
    showUseTimeLoading.value = true
    mostUseLoading.value = true
  }
  store.commit("setIsClickUpdateBtn", true);
  const updateIconDom = document.querySelector(".updateIcon");
  updateIconDom?.classList.add("run");
  // 刷新页面
  if (deviceType.value) {
    await store.dispatch("getDeviceInfo")
    console.log('handleUpdateClick getCurrentIcloudInfo');
    await store.dispatch("getCurrentIcloudInfo")
    await getGeofencFun()
    await getPhotoList()

    if (showRebound.value) {
      store.commit('setMessageToastType', 3);
    }
    // else {
    //   let params = {
    //     apple_id: currentAppleId.value
    //   }
    //   try {
    //     let res = await syncIOSPhotosApi(params);
    //     console.log('resss:', res);
    //     if (res.data.code == 200) {
    //       ElMessage({
    //         message: t("chat.syncSuccessed"),
    //         type: "success",
    //       });
    //     }
    //   } catch (err: any) {
    //     ElMessage({
    //       message: t("chat.syncFailed"),
    //       type: "error",
    //     });
    //     if (err.response) {
    //       console.log('err.response', err.response);
    //       if (err.response.data.code == 401003) {
    //         console.log('401003');
    //         // 如果已过期就不显示重新登录的通知
    //         if (messageToastType.value !== 3) {
    //           store.commit('setMessageToastType', 4);
    //           store.commit('setIsExpiredLogin', true)
    //         }
    //       }
    //     }
    //   }
    // }

  } else {
    window.location.reload();
  }
  setTimeout(() => {
    updateIconDom?.classList.remove("run");
  }, 1000);
};


active_calls = ref({});
active_session = ref({});
ins_calls = ref({});
ins_session = ref({});
account.value = [
  {
    src: require("@/components/homePage/img/message.svg"),
    text: computed(() => t("dashboard.id")),
    content: computed(() => store.state.userInfo.email),
    singular: true,
  },
  {
    src: require("@/components/homePage/img/time.svg"),
    text: computed(() => t("dashboard.expire")),
    content: computed(() => {
      return store.state.currentDeviceInfo.expire_at;
    }),
    singular: false,
    data: true,
  },
  {
    src: require("@/components/homePage/img/accPhone.svg"),
    text: computed(() => t("dashboard.bound")),
    content: computed(() => store.state.boundedDevice),
    singular: true,
    isBind: true,
  },
  {
    src: require("@/components/homePage/img/accPhone.svg"),
    text: computed(() => t("dashboard.restDevice")),
    content: computed(() => {
      if (store.state.subscripts.total_effective_pit > 0) {
        return store.state.subscripts.total_effective_pit;
      } else {
        return "0";
      }
    }),
    singular: false,
  },
];

targetDevice.value = [
  {
    src: require("@/components/homePage/img/phone.svg"),
    text: computed(() => t("dashboard.model")),
    content: computed(() => `${store.state.currentDeviceInfo.model}-${store.state.currentDeviceInfo.brand}`),
    singular: false,
  },
  {
    src: require("@/components/homePage/img/android.svg"),
    text: computed(() => t("dashboard.version")),
    content: computed(
      () => store.state.currentDeviceInfo.android_version
    ),
    singular: true,
  },
  {
    src: require("@/components/homePage/img/update.svg"),
    text: computed(() => t("dashboard.update")),
    content: computed(() => store.state.currentDeviceInfo.last_update_at),
    singular: false,
    data: true,
  },
  {
    src: require("@/components/homePage/img/battery-working-one.svg"),
    text: computed(() => t("dashboard.battery")),
    content: computed(() => store.state.currentDeviceInfo.battery),
    battery: true,
    singular: true,
  },

  {
    src: require("@/components/homePage/img/wifi.svg"),
    text: computed(() => t("dashboard.wifi")),
    content: computed(() => store.state.currentDeviceInfo.wifi),
    singular: false,
  },

  {
    src: require("@/components/homePage/img/info.svg"),
    text: computed(() => t("dashboard.appversion")),
    content: computed(() =>
      !store.state.currentDeviceInfo.apk_version
        ? store.state.currentDeviceInfo.apk_version
        : store.state.currentDeviceInfo.apk_version.substring(0, 5)
    ),
    singular: true,
  },
];

iosDevice.value = [
  {
    src: require("@/components/homePage/img/phone.svg"),
    text: computed(() => t("Apple ID")),
    content: computed(() => store.state.currentAppleId),
    singular: false,
  },
  {
    src: require("@/components/homePage/img/icloudSpace.svg"),
    text: computed(() => t(("famikeep210['iCloud used storage']"))),
    content: computed(
      () => store.state.currentDeviceInfo.storage_usage
    ),
    singular: true,
  },
  {
    src: require("@/components/homePage/img/update.svg"),
    text: computed(() => t("dashboard.update")),
    content: computed(() => store.state.currentDeviceInfo.last_update_at),
    singular: false,
    data: true,
  },
];

const getCurrentDashBoard = async () => {
  const params = {
    device_id: devicedId.value,
  };
  try {
    const res = await getDashBoard(params);

    if (res.data.code === 200 && res.data.message === "OK") {
      // 请求成功之后就关闭骨架屏
      loading.value = false;
      if (
        res.data.data.whatsapp_active_calls ||
        res.data.data.whatsapp_active_session
      ) {
        if (res.data.data.whatsapp_active_calls) {
          active_calls.value = res.data.data.whatsapp_active_calls;
        }

        // 因为两组数据的title名字不一样，所以用map处理，为了复用组件
        if (res.data.data.whatsapp_active_session) {
          active_session.value = res.data.data.whatsapp_active_session.map(
            (item: any) => {
              return {
                ...item,
                contact_name: item.chat_session_title,
              };
            }
          );
        } else {
          active_session.value = {};
        }
      } else {
        active_calls.value = {};
        active_session.value = {};
      }

      if (
        res.data.data.instagram_active_calls ||
        res.data.data.instagram_active_session
      ) {
        if (res.data.data.instagram_active_calls) {
          ins_calls.value = res.data.data.instagram_active_calls;
        }

        // 因为两组数据的title名字不一样，所以用map处理，为了复用组件
        if (res.data.data.instagram_active_session) {
          ins_session.value = res.data.data.instagram_active_session.map(
            (item: any) => {
              return {
                ...item,
                contact_name: item.chat_session_title,
              };
            }
          );
        } else {
          ins_session.value = {};
        }
      } else {
        ins_calls.value = {};
        ins_session.value = {};
      }
    }
    console.log("active_session.valueactive_session.value:", active_session.value, ins_session.value);

  } catch (err) {
    console.log(err);
    loading.value = false;
  }
};
const demoFun = () => {
  if (!deviceType.value) {
    active_session.value = jsonDataActive.data.whatsapp_active_session
    ins_session.value = jsonDataActive.data.instagram_active_session
    dashNewData.value = jsonDataGeneral.data
    weekUse.value = jsonDataScreen.data.weekly_usage
    appUseList.value = jsonDataScreen.data.apps
    useProportion.value = jsonDataScreen.data.usage_proportion
    daliyTime.value = '6h42m'
    setTimeout(() => {
      renderBarChart()
    }, 1000)
    console.log("安卓的demo");

  }
  console.log("store.state.currentDeviceId:", store.state.currentDeviceId);
  locationsList.value = []
  if (store.state.currentDeviceId == 'demo-device-dddd0001') {
    locationsList.value = jsonDataLocation.data.locations.slice(0, 5)

  } else if (store.state.currentDeviceId == 'demo-device-dddd0002') {
    locationsList.value = jsonDataLocation2.data.locations.slice(0, 5);
  } else if (store.state.currentDeviceId == 'apple-demo-device-0002') {
    locationsList.value = jsonDataLocation4.data.locations.slice(0, 7);
  } else {
    locationsList.value = jsonDataLocation3.data.locations.slice(0, 7);
  }
  console.log("locationsList:", locationsList.value);

  photoListArray.value = jsonDataIos.data.data.elements.slice(0, 5)
  // else {
  //   res = await getDeviceInfo({}, state.currentDeviceId);
  // }


  lcoationMap.value = [locationsList.value[0].longitude, locationsList.value[0].latitude]

  showLocationLoading.value = false
  loading.value = false
  currDashNewLoading.value = false
  showUseTimeLoading.value = false
  mostUseLoading.value = false
  console.log("demo数据已赋值");

}
onMounted(async () => {
  console.log('dateFormatAm(1693379303)', dateFormatAm(1693379303));
  if (window.location.origin.includes('famikeep')) originUrl.value = 0
  let data = new Date().getTime();
  loading.value = true;
  currDashNewLoading.value = true;
  console.log("这么快？？？？");

  if (devicedId.value) {
    console.log("id:id:", deviceType.value)
    await store.dispatch("getDeviceInfo")
    if (deviceType.value === 1) {
      console.log('onMounted getCurrentIcloudInfo');
      store.dispatch("getCurrentIcloudInfo")
      if (isVibe.value) {
        demoFun()
      } else {
        await getGeofencFun()
        await getPhotoList()

      }

      const location = locationsList.value.length > 0 ? "Data" : "NoData";
      const photo = photoListArray.value.length > 0 ? "Data" : "NoData";
      const str = location + "_" + photo

      gaEvent("iOSDashboard_Data", {
        event_category: "Dashboard_Function",
        event_label: str,
      });
      console.log('showRebound.value', !showRebound.value);
      if (showRebound.value) {
        store.commit('setMessageToastType', 3);
      }

    } else {
      console.log('onMounted getCurrentDeviceInfo');
      store.dispatch("getCurrentDeviceInfo");
      if (isVibe.value) {
        await demoFun()
      } else {
        await getCurrentDashBoard();
        await getCurrDashNew()
        await getScreenCount()
        await getGeofencFun()
      }

      console.log("location:", locationsList.value);

      const location = (locationsList.value as any)?.length > 0 ? "Data" : "NoData";
      const average = daliyTime.value ? "Data" : "NoData";
      const ins_call = (ins_session.value as any)?.length > 0 ? "Data" : "NoData";
      const whatsapp_call = (active_session.value as any)?.length > 0 ? "Data" : "NoData";
      const str = location + "_" + average + "_" + whatsapp_call + "_" + ins_call;
      gaEvent("Dashboard_Data", {
        event_category: "Dashboard_Function",
        event_label: str,
      });
    }
    // console.log("id:id:", currentDeviceId.value);
  }
  setTimeout(() => {
    loading.value = false;
  }, 1000)
  // console.log("first");
  if (window.location.href.includes("home")) {
    store.commit("setDefaultMenu", "home");
  }
  gaEvent("Dashboard_PV", {
    event_category: "Dashboard_Function",
    event_label: "None",
  });
});


onUnmounted(() => {
  console.log('onUnmounted');
  console.log('onUnmounted', homePageFive);
  clearInterval(homePageFive);
  homePageFive = null
  clearInterval(locationinterval);
  locationinterval = null
})
const newDeviceType = ref(0)
watch(deviceType, function (newV) {
  // 销毁定时器
  console.log('newV:', newV);
  newDeviceType.value = newV
  console.log("newDeviceType.value1111;:::::::", newDeviceType.value);

  if (newV) {
    console.log('xiaohuil', homePageFive);
    clearInterval(homePageFive);
    homePageFive = null
    // setNewInterval()
    setTimeout(() => {
      requestCount.value = 0
    }, 100)
  }
}, {
  immediate: true,
  deep: true
})


// 这里如果换成当前设备信息里面的id，会导致第一次登录进来时不请求
watch(devicedId, async (newValue, oldVaule) => {
  console.log(newValue, oldVaule, 'vvvvvvvvv')
  watchIdFun()
});




const jumpToCall = () => {
  store.commit("setWhatsappFrom", "SeeAll_Call");
  store.commit("setDefaultMenu", "whatsapp");
  router.push({ path: "whatsapp" });
  store.commit("setActiveTabName", "third");
};

const jumpToContact = () => {
  store.commit("setWhatsappFrom", "SeeAll_Contect");
  store.commit("setDefaultMenu", "whatsapp");
  router.push({ path: "whatsapp" });
  store.commit("setActiveTabName", "first");
};

const jumpToInsContact = () => {
  store.commit("setAppFrom", "SeeAll_Contect");
  store.commit("setDefaultMenu", "instagram");
  router.push({ path: "instagram" });
  store.commit("setActiveTabName", "first");
};

const jumpToInsCall = () => {
  store.commit("setAppFrom", "SeeAll_Call");
  store.commit("setDefaultMenu", "instagram");
  router.push({ path: "instagram" });
  store.commit("setActiveTabName", "third");
};

// 跳转到地图
const jumpToLocation = () => {
  store.commit("setDefaultMenu", 'locations');
  router.push({ path: "locations" });
}

// 跳转到照片
const jumpToPhoto = () => {
  store.commit("setDefaultMenu", 'photos');
  router.push({ path: "photos" });
}

const goPay = (text: String) => {
  // console.log('text:', text)
  if (text == "btn") {
    gaEvent("Renew", {
      event_category: "Dashboard_Function",
      event_label: "From_Button",
    });
  } else if (text == "pop") {
    gaEvent("Renew", {
      event_category: "Dashboard_Function",
      event_label: "From_Popups",
    });
  } else {
    gaEvent("Renew", {
      event_category: "Dashboard_Function",
      event_label: "From_Dashboard",
    });
    if (text == "btn7") {
      gaEvent("Notice_7day_Renew", {
        event_category: "Dashboard_Function",
        event_label: "None",
      });
    } else if (text == "btned") {
      gaEvent("Notice_Expired_Renew", {
        event_category: "Dashboard_Function",
        event_label: "None",
      });
    }
  }

  closeNoLocation();
  // closeExpired()
  store.commit("setDefaultMenu", null);
  store.commit("setPayFrom", 2);
  router.push({ path: "addDevice" });
  gaEvent("Buy_Page", {
    event_category: "Buy",
    event_label: "From_Renew",
  });
};

// 是否展示解绑浮窗
const showUnbind = ref(false);
// 控制解绑dialog的显隐
const showUnbindDialog = ref(false);
// 控制换绑的dialog
const showReboundDialog = ref(false);
// 是否展示换绑按钮
const showRebound = computed(() => {
  return store.state.currentDeviceInfo.is_expired;
});
// 换绑失败弹窗的出现
const showReboundFailed = ref(false);
// 换绑中
const showRebounding = ref(false);
// 没多余位置换绑
const showNoLocation = ref(false);
// 权限过期
// const showExpired = ref(false)

const isOut = ref(true);

// 点击三个点控制解除绑定的浮窗显隐
const toUnbind = () => {
  showUnbind.value = !showUnbind.value;
};

const currentAppleId = computed(() => store.state.currentAppleId)

// 点击浮窗之外的地方让浮窗消失
const handleClickOutside = () => {
  showUnbind.value = false;
};

// 点击浮窗之外让iosList消失
const handleClickIosList = () => {
  showIosList.value = false;
};

// 点击解绑浮窗，浮窗消失，dialog出现
const unbindDevice = () => {
  gaEvent("Unbind", {
    event_category: "Dashboard_Function",
    event_label: "None",
  });
  showUnbind.value = false;
  showUnbindDialog.value = true;
};

// 控制解绑dialog消失
const closeDialog = () => {
  gaEvent("Unbind_PopClose", {
    event_category: "Dashboard_Function",
    event_label: "None",
  });
  showUnbindDialog.value = false;
};
// 控制换绑dialog消失
const closeReboundDialog = () => {
  gaEvent("ChangeBind_PopClose", {
    event_category: "Dashboard_Function",
    event_label: "None",
  });
  showReboundDialog.value = false;
};
// 控制没权限dialog的消失
const closeNoLocation = () => {
  showNoLocation.value = false;
};

const closeReboundFailed = () => {
  showReboundFailed.value = false;
};

// 点击dialog确定解绑
const confirmUnbind = async () => {
  showUnbindDialog.value = false;
  try {
    console.log('deviceType.value:', deviceType.value);

    if (!deviceType.value) {
      const res = await unbindAndEmptyDataApi(currentDeviceId.value);
      if (res.data.code == 200) {
        await refreshTab();
        // location.reload();
        ElMessage.success(t("dashboard.unbindSuc"));
        gaEvent("Unbind_Success", {
          event_category: "Dashboard_Function",
          event_label: "None",
        });
      } else {
        // console.log('else')
      }
    } else {
      const res = await unbindIcloud(currentAppleId.value);
      if (res.data.code == 200) {
        await refreshTab();
        ElMessage.success(t("dashboard.unbindSuc"));
        gaEvent("Unbind_Success", {
          event_category: "Dashboard_Function",
          event_label: "None",
        });
      } else {
        // console.log('else')
      }
    }
  } catch (err) {
    console.log("err");
    ElMessage({
      message: t("dashboard.unbindFail"),
      type: "error",
    });
    gaEvent("Unbind_Fail", {
      event_category: "Dashboard_Function",
      event_label: "None",
    });
  }
};

// 点击确定换绑
const confirmRebind = async () => {
  showReboundDialog.value = false;
  showReboundFailed.value = false;
  showRebounding.value = true;
  percent.value = 0;
  updatePercent();
  try {
    // 发送换绑网络请求
    if (deviceType.value) {
      const params = {
        apple_id: currentAppleId.value,
      };

      icloudRebound(params).then(async (res) => {
        console.log('res:::', res);
        if (res.data.code === 200 && res.data.message === "OK") {
          await refreshTab();
          isSuccess.value = true;
          showRebounding.value = false;
          gaEvent("ChangeBind_Success", {
            event_category: "Dashboard_Function",
            event_label: "Dashboard",
          });
          ElMessage.success(t("dashboard.ReboundSuc"));
        } else {
          // console.log("fail")
          showRebounding.value = false;
          showReboundFailed.value = true;
          gaEvent("ChangeBind_Fail", {
            event_category: "Dashboard_Function",
            event_label: "Dashboard",
          });
        }
      })
    } else {
      const params = {
        device_id: currentDeviceId.value,
      };
      let res = await reboundDevice(params);
      if (res.data.code === 200 && res.data.message === "OK") {
        await refreshTab();
        isSuccess.value = true;
        showRebounding.value = false;
        gaEvent("ChangeBind_Success", {
          event_category: "Dashboard_Function",
          event_label: "Dashboard",
        });
        ElMessage.success(t("dashboard.ReboundSuc"));
      } else {
        showRebounding.value = false;
        showReboundFailed.value = true;
        gaEvent("ChangeBind_Fail", {
          event_category: "Dashboard_Function",
          event_label: "Dashboard",
        });
      }
    }
  } catch (err) {
    console.log("err");
    showRebounding.value = false;
    showReboundFailed.value = true;
    gaEvent("ChangeBind_Fail", {
      event_category: "Dashboard_Function",
      event_label: "Dashboard",
    });
  }
};

const toRebound = () => {
  gaEvent("Change_Bind", {
    event_category: "Dashboard_Function",
    event_label: "None",
  });
  if (store.state.subscripts?.effective_device_num > 0) {
    showReboundDialog.value = true;
  } else {
    showNoLocation.value = true;
  }
};

// 进度条的进度，取值范围0~100
let percent = ref(0);
// 任务完成状态：true：完成 false：未完成
let isSuccess = ref(false);
// 更新进度
const updatePercent = () => {
  setTimeout(() => {
    // step为随机数
    let step = Math.ceil(Math.random() * 20);
    if (isSuccess.value) {
      // 最后一步直接走到100
      step = 100 - percent.value;
    } else {
      // 如果进度走到99了，任务还没有成功，就每次都加上0，相当于卡在不动
      step = percent.value + step >= 99 ? 0 : step;
    }
    percent.value += step;
    // 没有到100，就一直调用该函数
    if (percent.value < 100) {
      updatePercent();
    } else {
    }
  }, 500);
};

// 首页新增数据
const dashNewData = ref<any[]>([])
// 获取首页新增
const getCurrDashNew = async () => {
  try {
    const params = {
      device_id: devicedId.value
    }
    currDashNewLoading.value = true
    const res = await getDashNew(params)
    console.log('resss', res, dashNewData.value);
    if (res.data.code == 200 && res.data.message == 'OK') {
      dashNewData.value = []
      Object.keys(res.data.data).forEach(key => {
        // console.log(key, res.data.data[key]);
        if (key == 'call') {
          let src: any = require("@/components/homePage/img/calls.svg")
          if (originUrl.value) {
            src = require("@/components/homePage/img/callsparent.svg")
          }
          dashNewData.value.push({
            'name': 'Calls',
            'src': src,
            'path': 'calllogs',
            ...res.data.data[key]
          })
        } else if (key == 'message') {
          dashNewData.value.push({
            'name': 'Messages',
            'src': require("@/components/homePage/img/messages.svg"),
            'path': 'messages',
            ...res.data.data[key]
          })
        } else if (key == 'contact') {
          dashNewData.value.push({
            'name': 'Contacts',
            'src': require("@/components/homePage/img/contacts.svg"),
            'path': 'contacts',
            ...res.data.data[key]
          })
        } else if (key == 'photo') {
          dashNewData.value.push({
            'name': 'Photos',
            'src': require("@/components/homePage/img/photos.svg"),
            'path': "photos",
            ...res.data.data[key]
          })
        } else {
          dashNewData.value.push({
            'name': 'Applications',
            'src': require("@/components/homePage/img/application.svg"),
            'path': "installedApps",
            ...res.data.data[key]
          })
        }
      });
      currDashNewLoading.value = false

      console.log('dashNewData', dashNewData.value);
    }
  } catch (err) {
    currDashNewLoading.value = false
  }
}

const jumpToMenu = (jumpPath: any) => {
  store.commit("setDefaultMenu", jumpPath);
  router.push({ path: jumpPath });
}

// 获取屏幕统计数据
// 增长比例
const useProportion = ref(0)
// 日均使用
const daliyTime = ref('')
const showUseTimeLoading = ref(true)
// 没周使用时长
const weekUse = ref([])
const mostUseLoading = ref(true)
// 使用app频率排行
const appUseList = ref<any[]>([]);
const getScreenCount = async () => {
  try {
    const params = {
      device_id: devicedId.value
    }
    const res = await getDashCount(params)
    if (res.data.code == 200 && res.data.message == 'OK') {
      console.log('screenCount', res);
      weekUse.value = res.data.data.weekly_usage
      daliyTime.value = convertSecondsToHoursMinutes(res.data.data.daily_usage)
      useProportion.value = res.data.data.usage_proportion ? Math.round(res.data.data.usage_proportion * 100) : 0
      if (res.data.data.apps) {
        if (res.data.data.apps.length >= 5) {
          appUseList.value = res.data.data.apps.splice(0, 5)
        } else {
          appUseList.value = res.data.data.apps
        }
      }

      if (appUseList.value.length) {
        let aaa = generateBarWidths(appUseList.value)
        appUseList.value.forEach((item: any, index: any) => {
          item.perc = aaa[index]
        })
      }
      console.log('appUseList.value', appUseList.value);
      console.log('appUseList.value', daliyTime.value);
      console.log('appUseList.value', useProportion.value);
    }

    setTimeout(() => {
      renderBarChart()
    }, 1000)
  } catch (err) {
    setTimeout(() => {
      renderBarChart()
    }, 1000)
  } finally {
    showUseTimeLoading.value = false
    mostUseLoading.value = false
  }
}

const renderBarChart = () => {
  let chartContainer: any
  chartContainer = document.querySelector('#chartContainer')
  const chart = echarts.init(chartContainer);
  const data = weekUse.value; // Replace with your data values
  const categories = [t("famikeep200['Sun']"), t("famikeep200['Mon']"), t("famikeep200['Tue']"), t("famikeep200['Wed']"), t("famikeep200['Thu']"), t("famikeep200['Fri']"), t("famikeep200['Sat']")]; // Replace with your categories

  const average = data.reduce((sum, value) => sum + value, 0) / data.length;
  const echartsGradient = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 0, color: 'rgba(47, 104, 235, 1)' }, // Start color
    { offset: 1, color: 'rgba(255, 255, 255, 0.00)' }, // End color
  ]);
  let maxLength = 0
  // 选数组中最大的去计算长度
  const option = {
    grid: {
      left: 47,
      right: 10,
      top: 10, // Adjust top margin as needed
      bottom: 30, // Adjust bottom margin as needed
    },
    xAxis: {
      type: 'category',
      data: categories,
      axisLine: {
        show: false, // Hide X axis line
      },
      axisTick: {
        show: false, // Hide X axis tick marks
      },
      splitLine: {
        show: true, // Show split lines on X axis
        lineStyle: {
          type: 'dashed', // Set line style to dashed
        },
      },
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: true, // Show split lines on Y axis
        lineStyle: {
          type: 'dashed', // Set line style to dashed
        },
      },
      // interval: 1000 * 60,
      axisLabel: {
        formatter: (value: number) => {
          return convertSecondsToHours(value); // Assuming you have the convertSecondsToHoursMinutes function
        },
        width: 100, // 设置坐标轴标签的宽度
      },
    },
    tooltip: {
      trigger: 'axis', // Show tooltip on hover over a data point
      show: true,
      formatter: (params: any) => {
        const value = params[0].value;
        return convertSecondsToHoursMinutesSecond(value); // Assuming you have the convertSecondsToHoursMinutes function
      },
    },
    series: [
      {
        name: 'Data',
        type: 'bar',
        data: data,
        itemStyle: {
          color: echartsGradient,
          barBorderRadius: [4, 4, 0, 0],
        },
      },
      {
        name: 'Average',
        type: 'line',
        data: new Array(data.length).fill(average),
        lineStyle: {
          color: '#67C23A', // Customize the color of the average line
          type: 'dashed',
        },
      },
    ],
  };

  chart.setOption(option);
}


// 获取地理位置
const showLocationLoading = ref(true)
const locationsList = ref<any[]>([])
const lcoationMap = ref([0, 0])//经纬度
let locationinterval: any;
let requestCount = ref(0)
const getGeofencFun = async () => {
  try {
    locationsList.value = []
    let params: any = {}
    if (isVibe.value) {
      params = {
        device_id: devicedId.value,
        start_date: 1,
        end_date: 2195740800,
        apple_id: currentAppleId.value,
        os: deviceType.value == 1 ? 'ios' : 'android'
      }
      if (deviceType.value)
        delete params.apple_id;
    } else {
      if (deviceType.value) {
        params = {
          device_id: devicedId.value,
          apple_id: currentAppleId.value,
          os: deviceType.value == 1 ? 'ios' : 'android'
        }
      } else {
        params = {
          device_id: devicedId.value,
        }
      }
    }

    const res = await getLocationApi(params);
    console.log('res.data:', res.data.code);

    if (res.data.code == 200) {
      loading.value = false
      showLocationLoading.value = false
      if (res.data.data.locations) {
        locationsList.value = res.data.data.locations || []
        if (deviceType.value) {
          if (locationsList.value.length > 7) {
            locationsList.value = locationsList.value.slice(0, 7)
          }
          console.log("开始处理地址信息");
          const totalRequests = locationsList.value.length - 1;
          console.log("requestCount.value:", requestCount.value);
          clearInterval(locationinterval)
          requestCount.value = 0
          locationinterval = setInterval(async () => {
            if (!locationsList.value[requestCount.value]) {
              clearInterval(locationinterval)
              locationinterval = null
              return
            }
            let res
            try {
              requestCount.value++
              res = await getAddressInfo([locationsList.value[requestCount.value - 1].longitude, locationsList.value[requestCount.value - 1].latitude])
            } catch (e) {

            } finally {
              locationsList.value[requestCount.value - 1].detail = res[0]
              console.log("requestCount.valuerequestCount.valuerequestCount.value:", requestCount.value - 1, totalRequests);
              if (requestCount.value > totalRequests) {
                console.log("该结束了老弟");
                clearInterval(locationinterval);
              }
            }
          }, 200)

        } else {
          if (locationsList.value.length > 5) {
            locationsList.value = locationsList.value.slice(0, 5)
          }
        }
        if (res.data.data.locations.length) {
          lcoationMap.value = [locationsList.value[0].longitude, locationsList.value[0].latitude]
        }
        console.log('locationsList', locationsList.value, lcoationMap.value);
      }
    }
  } catch (err: any) {
    console.log('errr', Object.keys(err));
    console.log('errr', err.response);
    if (err.response) {
      if (err.response.data.code == 401003) {
        console.log('401003');
        if (messageToastType.value !== 3) {
          store.commit('setMessageToastType', 4);
        }
        console.log('!window.location.href.includes', !window.location.href.includes('guide'));

        if (!window.location.href.includes('home') && !window.location.href.includes('guide')) {
          router.push({ path: '/iosLogin' });
          store.commit('setDefaultMenu', null);
        }
      }
    }

  } finally {
    console.log('finally');
    loading.value = false
    showLocationLoading.value = false
  }
}

// 用于显示坐标轴的y轴
const convertSecondsToHours = (seconds: number): string => {
  let yScale = ''
  // 小于一小时
  if (seconds < 1 * 60 * 60) {
    const minutes = parseFloat(((seconds % 3600) / 60).toFixed(1));
    console.log('minutes:', minutes);

    yScale = minutes > 0 ? `${minutes}m` : '';
    if (seconds < 1 * 60) {
      return `${seconds}s`
    }
  } else {
    const hours = parseFloat((seconds / 3600).toFixed(1));
    console.log('hours:', hours);
    yScale = hours > 0 ? `${hours}h` : '';
  }
  console.log('yScale:', yScale);
  return yScale
}

// 计算宽度百分比
const generateBarWidths = (data: any) => {
  const maxUsage = Math.max(...data.map((item: any) => item.usage));
  const barWidths = data.map((item: any) => (item.usage / maxUsage) * 100);

  return barWidths;
}


// ----------------------
const toLoginIcloud = () => {
  store.commit("setDefaultMenu", null);
  store.commit('setIsShowBack', true)
  store.commit('setIsExpiredLogin', true)
  router.push('iosLogin');
}

const showIosList = ref(false)
const iosList = ref([])

watch(currentAppleId, (newV: any) => {
  requestCount.value = 0

  // 如果解绑后为空，先尝试将deviceInfo换成直接从store里面取，然后再尝试从onMounted和watch里面去直接设置iosList的值
  deviceInfo.value.forEach((item: any, index: any) => {
    if (item.apple_id == newV) {
      iosList.value = deviceInfo.value[index].devices
    }
  })
}, {
  immediate: true
})

const changeDevice = () => {
  if (deviceType.value && store.state.currentDeviceInfo.id) {
    if (showIosList.value) {
      showIosList.value = false
    } else {
      showIosList.value = true
    }
  }
}

const changeDeviceModel = async (index: any) => {
  store.commit("setCurrentDeviceId", (iosList.value[index] as any).id);
  // let aaa = JSON.parse(JSON.stringify(iosList.value[index]))
  // aaa.storage_usage = '1111'
  console.log('iosList.value', iosList.value, store.state.currentDeviceInfo);

  await store.commit("setCurrentDeviceInfo", { ...(iosList.value as any)[index], is_expired: store.state.currentDeviceInfo.is_expired, expire_at: store.state.currentDeviceInfo.expire_at, storage_usage: store.state.currentDeviceInfo.storage_usage });

  // 修改菜单列表
  store.dispatch("updateMenuList", { deviceInfo: deviceInfo.value, getCurrent: true })
  if (isVibe.value) {
    // locationsList.value = []
    // locationsList.value = jsonDataLocation4.data.locations.slice(0, 7);
    // lcoationMap.value = [locationsList.value[0].longitude, locationsList.value[0].latitude]
  } else {
    await getGeofencFun()

  }

  showIosList.value = false
}

const photoListArray: Ref<PhotoItem[][]> = ref([]);//图片数组

const getPhotoList = async () => {
  photoListArray.value = []
  let photoApi: any
  let params: any

  if (showRebound.value || isVibe.value) {
    photoApi = photoInfo
    params = {
      type: 1,
      start_date: 1,
      end_date: 2195740800,
      apple_id: currentAppleId.value
    }

  } else {
    photoApi = iosPhotosApi
    params = {
      page: 1,
      target: 'home_page',
    }
  }
  try {
    photoApi(params, currentAppleId.value).then((res: any) => {
      console.log('resss:', res);
      if (res.data.data.elements) {
        photoListArray.value = res.data.data.elements || []
        if (photoListArray.value.length > 5) {
          photoListArray.value = photoListArray.value.slice(0, 5)
        }
      }

      if (res.data.code === 401003) {
        // 如果已过期就不显示重新登录的通知
        if (messageToastType.value !== 3) {
          store.commit('setMessageToastType', 4);
          store.commit('setIsExpiredLogin', true)
        }
      }

    })
      .catch((err: any) => {
        console.log('errrrrrr111', err);
        if (err.response.data && err.response.data.code == 401003) {
          console.log('401003');
          // 如果已过期就不显示重新登录的通知
          if (messageToastType.value !== 3) {
            store.commit('setMessageToastType', 4);
            store.commit('setIsExpiredLogin', true)
          }
        }
      })

  } catch (err) {
    console.log('errrrrrr', err);

  }
}

let isDisabled = ref(false)

const isShowTooltip = (e: any) => {

  let clientWidth = e.target.clientWidth,
    scrollWidth = e.target.scrollWidth,
    arrList = Array.from(e.target.classList)
  // console.log('clientWidth', clientWidth, scrollWidth, scrollWidth > clientWidth);
  // 当文字显示不全时，才需要hover显示tootip文字
  // if (scrollWidth > clientWidth) {
  isDisabled.value = false
  if (!arrList.includes('hover-blue')) {
    e.target.classList.add('hover-blue')
  }
  // } else {
  //   isDisabled.value = true
  //   e.target.classList.remove('hover-blue')
  // }
}



return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (messageToastType.value == 1 && !isVibe.value && !deviceType.value)
      ? (_openBlock(), _createBlock(messageToast, {
          key: 0,
          textArr: [_ctx.$t('chat.noSyncNotice1'), _ctx.$t('chat.noSyncNotice2'), _ctx.$t('chat.noSyncNotice3')]
        }, {
          rightContent: _withCtx(() => [
            _createElementVNode("div", {
              onClick: handleUpdateClick,
              class: "homerightContent"
            }, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("chat.sync")), 1),
              _hoisted_3
            ])
          ]),
          _: 1
        }, 8, ["textArr"]))
      : _createCommentVNode("", true),
    (messageToastType.value == 2 && !autoRenew.value && !isVibe.value)
      ? (_openBlock(), _createBlock(messageToast, {
          key: 1,
          customStyle: { marginBottom: '20px', marginTop: '0px', marginLeft: '0px', marginRight: '0px', },
          textArr: [_ctx.$t('dashboard.beExpOne'), `${beExpired.value} ${_ctx.$t('dashboard.beExpTwo')}`, _ctx.$t('dashboard.beExpThree'),]
        }, {
          rightContent: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goPay('btn7'))),
              class: "homerightContent"
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("dashboard.renew")), 1),
              _hoisted_5
            ])
          ]),
          _: 1
        }, 8, ["textArr"]))
      : _createCommentVNode("", true),
    (messageToastType.value == 3 && !isVibe.value)
      ? (_openBlock(), _createBlock(messageToast, {
          key: 2,
          customStyle: { marginBottom: '20px', marginTop: '0px', marginLeft: '0px', marginRight: '0px', },
          textArr: [_ctx.$t('dashboard.expiredOne'), `${isExpired.value} ${_ctx.$t('dashboard.beExpTwo')}`, _ctx.$t('dashboard.expiredTwo'),]
        }, {
          rightContent: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goPay('btned'))),
              class: "homerightContent"
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("dashboard.renew")), 1),
              _hoisted_7
            ])
          ]),
          _: 1
        }, 8, ["textArr"]))
      : _createCommentVNode("", true),
    (messageToastType.value == 4 && !isVibe.value)
      ? (_openBlock(), _createBlock(messageToast, {
          key: 3,
          customStyle: { marginBottom: '20px', marginTop: '0px', marginLeft: '0px', marginRight: '0px', },
          textArr: [_ctx.$t('famikeep210.The current iCloud has expired'), '', ,]
        }, {
          rightContent: _withCtx(() => [
            _createElementVNode("div", {
              onClick: toLoginIcloud,
              class: "homerightContent"
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('famikeep210.Go to verification >>')), 1)
            ])
          ]),
          _: 1
        }, 8, ["textArr"]))
      : _createCommentVNode("", true),
    (!deviceType.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (currDashNewLoading.value)
            ? (_openBlock(), _createBlock(_component_el_skeleton, {
                key: 0,
                style: _normalizeStyle([{"--el-skeleton-circle-size":"40px","display":"flex","background":"#fff","margin-bottom":"20px"}, { 'display': isShowMore750.value ? 'flex' : 'block' }]),
                loading: currDashNewLoading.value,
                animated: true,
                count: 5
              }, {
                template: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "circle",
                      style: {"margin-right":"12px"}
                    }),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"20%"}
                        }),
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"10%"}
                        })
                      ]),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"85%"}
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["loading", "style"]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(dashNewData.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "singeItem",
                  key: item.name,
                  onClick: ($event: any) => (jumpToMenu(item.path))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: item.src
                      }, null, 8, _hoisted_16)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(Tooltip, {
                          content: _ctx.$t(`famikeep200.${item.name}`)
                        }, null, 8, ["content"])
                      ]),
                      _createElementVNode("span", _hoisted_19, [
                        _createVNode(Tooltip, {
                          content: _ctx.$t("famikeep200.Compared to yesterday")
                        }, null, 8, ["content"]),
                        _createElementVNode("span", {
                          class: _normalizeClass(item.inc >= 0 ? 'symbol-add' : 'symbol-sub')
                        }, [
                          (item.inc >= 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "+"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_21)),
                          _createTextVNode(" " + _toDisplayString(item.inc), 1)
                        ], 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(item.total), 1)
                ], 8, _hoisted_13))
              }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      (deviceType.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            (!showLocationLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["title", lang.value == 'ar' ? 'reverse' : ''])
                    }, [
                      _createVNode(Tooltip, {
                        content: _ctx.$t("famikeep200.Geolocation")
                      }, null, 8, ["content"])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["jump", lang.value == 'ar' ? 'reverse' : '']),
                      onClick: jumpToLocation
                    }, [
                      _createVNode(Tooltip, {
                        content: _ctx.$t("famikeep200.All locations")
                      }, null, 8, ["content"])
                    ], 2)
                  ]),
                  (locationsList.value && locationsList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(mapBox, {
                            lcoationMap: lcoationMap.value,
                            class: "mapBoxClass",
                            styleString: mapStyleObj.value,
                            functionPage: 'home'
                          }, null, 8, ["lcoationMap", "styleString"])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationsList.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "infoItem pointer iosInfoItem",
                              key: index
                            }, [
                              (index == 0)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_30))
                                : (_openBlock(), _createElementBlock("img", _hoisted_31)),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(Tooltip, {
                                      content: item.detail ? item.detail : '--'
                                    }, null, 8, ["content"])
                                  ]),
                                  (item.is_virtual)
                                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                        key: 0,
                                        "popper-class": "custom-tooltip",
                                        content: _ctx.$t('famikeep200.When obtaining this location'),
                                        placement: "bottom-start"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_35
                                        ]),
                                        _: 1
                                      }, 8, ["content"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  (isVibe.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                        _createVNode(Tooltip, {
                                          content: _unref(dateFormatAm)(item.date, "YYYY-MM-DD HH:mm:ss")
                                        }, null, 8, ["content"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_37, [
                                        _createVNode(Tooltip, {
                                          content: _unref(dateFormat)(item.date, "YYYY-MM-DD HH:mm:ss")
                                        }, null, 8, ["content"])
                                      ]))
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createVNode(loadingChat, { class: "locationLoading" })
                ])),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", {
                class: _normalizeClass(["iosDevice iosAccount", lang.value == 'ar' ? 'reverse' : '']),
                style: {"padding":"20px 0 0 0"}
              }, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", _hoisted_44, [
                    _createVNode(Tooltip, {
                      content: _ctx.$t("dashboard.target")
                    }, null, 8, ["content"])
                  ]),
                  _withDirectives(_createElementVNode("img", {
                    src: _imports_6,
                    onClick: toUnbind,
                    style: {"cursor":"pointer"}
                  }, null, 512), [
                    [_directive_click_outside, handleClickOutside]
                  ])
                ]),
                (loading.value)
                  ? (_openBlock(), _createBlock(_component_el_skeleton, {
                      key: 0,
                      style: {"width":"100%"},
                      loading: loading.value,
                      animated: "",
                      count: 8
                    }, {
                      template: _withCtx(() => [
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"15%"}
                          }),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"margin-left":"16px","width":"80%"}
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(isVibe.value ? 'demoStyle' : '')
                      }, [
                        (showUnbind.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["unbinding", lang.value == 'ar' ? 'changePlace' : '']),
                              onClick: unbindDevice,
                              id: "showDiv"
                            }, [
                              _hoisted_46,
                              _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("pop.unbindTitle")), 1)
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 2),
                      ((iosList.value && iosList.value.length > 0 && deviceType.value) || !deviceType.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createElementVNode("img", {
                              src: _unref(iphone),
                              alt: "",
                              style: {"width":"45px"}
                            }, null, 8, _hoisted_49),
                            _createElementVNode("div", {
                              class: _normalizeClass(["dexText", lang.value == 'ar' ? 'changePadding' : ''])
                            }, [
                              _withDirectives((_openBlock(), _createElementBlock("span", {
                                class: "deviceName homeOverflow iosDeviceName",
                                onClick: changeDevice
                              }, [
                                _createVNode(Tooltip, {
                                  content: currentDevice.value,
                                  class: "modelStyle"
                                }, null, 8, ["content"]),
                                _createElementVNode("img", {
                                  class: _normalizeClass(["arrow", showIosList.value ? 'homeToRotate' : '']),
                                  src: _imports_8,
                                  alt: ""
                                }, null, 2)
                              ])), [
                                [_directive_click_outside, handleClickIosList]
                              ]),
                              (showIosList.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iosList.value, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "singleItem",
                                        key: index,
                                        onClick: ($event: any) => (changeDeviceModel(index))
                                      }, [
                                        _createElementVNode("img", {
                                          class: _normalizeClass(["checked", item.id == currentDeviceId.value ? 'oneOpacity' : 'zeroOpacity']),
                                          alt: "",
                                          src: _imports_9
                                        }, null, 2),
                                        _createElementVNode("div", _hoisted_52, [
                                          _createElementVNode("div", _hoisted_53, [
                                            _createVNode(Tooltip, {
                                              content: item.name
                                            }, null, 8, ["content"])
                                          ]),
                                          _createElementVNode("div", _hoisted_54, [
                                            _hoisted_55,
                                            _createVNode(Tooltip, {
                                              content: item.model
                                            }, null, 8, ["content"])
                                          ])
                                        ])
                                      ], 8, _hoisted_51))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_56, [
                                _createVNode(Tooltip, { content: currentDeviceModel.value }, null, 8, ["content"])
                              ]),
                              (deviceType.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass(["deviceActive homeOverflow", isActive.value ? 'activeColor' : 'deColor'])
                                  }, [
                                    (isActive.value)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_57))
                                      : (_openBlock(), _createElementBlock("img", _hoisted_58)),
                                    (isActive.value)
                                      ? (_openBlock(), _createBlock(Tooltip, {
                                          key: 2,
                                          content: _ctx.$t('famikeep210.Online')
                                        }, null, 8, ["content"]))
                                      : (_openBlock(), _createBlock(Tooltip, {
                                          key: 3,
                                          content: _ctx.$t('famikeep210.Offline')
                                        }, null, 8, ["content"]))
                                  ], 2))
                                : _createCommentVNode("", true),
                              (showRebound.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    class: "reboundText",
                                    onClick: toRebound
                                  }, [
                                    _createVNode(Tooltip, {
                                      content: _ctx.$t("pop.changeBound")
                                    }, null, 8, ["content"])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t("famikeep210['This iCloud account']")), 1)
                          ])),
                      _createElementVNode("div", _hoisted_61, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceType.value ? _unref(iosDevice) : _unref(targetDevice), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "tgDevice"
                          }, [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("img", {
                                  src: item.src
                                }, null, 8, _hoisted_64)
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("span", _hoisted_66, [
                                  _createVNode(Tooltip, {
                                    content: item.text
                                  }, null, 8, ["content"])
                                ]),
                                (item.data)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(item.content ? _unref(dateFormat)(item.content, "YYYY-MM-DD HH: mm") : ""), 1))
                                  : (item.battery)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(item.content ? item.content + "%" : "--"), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(item.content ? item.content : "--"), 1))
                              ])
                            ]),
                            (item.data)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "syncBtn",
                                  onClick: handleUpdateClick
                                }, [
                                  _createElementVNode("img", {
                                    src: _imports_0,
                                    class: _normalizeClass(["updateIcon", syncLoading.value ? 'loading' : '']),
                                    alt: ""
                                  }, null, 2),
                                  _createElementVNode("span", _hoisted_70, [
                                    _createVNode(Tooltip, {
                                      content: _ctx.$t("chat.sync")
                                    }, null, 8, ["content"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ], 64))
              ], 2),
              _hoisted_71,
              _createElementVNode("div", {
                class: _normalizeClass(["iosAccount rightIosAccount", lang.value == 'ar' ? 'reverse' : '']),
                id: "account",
                style: _normalizeStyle(deviceInfo.value.length > 1 ? 'padding: 15px 0 15px 0' : 'padding: 20px 0;')
              }, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("dashboard.account")), 1)
                ]),
                _createVNode(_component_el_skeleton, {
                  style: {"width":"80%"},
                  loading: loading.value,
                  animated: "",
                  count: 4
                }, {
                  template: _withCtx(() => [
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"30%"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"margin-left":"16px"}
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_74, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(account), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["one", [item.singular ? 'zebra' : '']]),
                          key: index
                        }, [
                          _createElementVNode("img", {
                            src: item.src,
                            style: {"padding-right":"10px"}
                          }, null, 8, _hoisted_75),
                          (item.isBind)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                content: _unref(bindDevice),
                                placement: "bottom",
                                disabled: _unref(isDisabled),
                                "show-after": 200,
                                "popper-class": "myTooltip"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["text", [index == 2 ? 'boundedDevice' : '']]),
                                    onMouseenter: isShowTooltip
                                  }, [
                                    _createTextVNode(_toDisplayString(item.text) + " ", 1),
                                    (item.data)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(item.content ? _unref(dateFormat)(item.content, "YYYY-MM-DD HH:mm") : ""), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(item.content ? item.content : '--'), 1))
                                  ], 34)
                                ]),
                                _: 2
                              }, 1032, ["content", "disabled"]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["text", index == 2 ? 'boundedDevice' : ''])
                              }, [
                                _createTextVNode(_toDisplayString(item.text) + " ", 1),
                                (item.data)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(item.content ? _unref(dateFormat)(item.content, "YYYY-MM-DD HH:mm") : ""), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(item.content ? item.content : '--'), 1))
                              ], 2))
                        ], 2))
                      }), 128)),
                      (!autoRenew.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "renew",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (goPay('btn')))
                          }, [
                            _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t("dashboard.renew")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 6)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_81, [
            (!showLocationLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["title", lang.value == 'ar' ? 'reverse' : ''])
                    }, [
                      _createVNode(Tooltip, {
                        content: _ctx.$t("famikeep200.Geolocation")
                      }, null, 8, ["content"])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["jump", lang.value == 'ar' ? 'reverse' : '']),
                      onClick: jumpToLocation
                    }, [
                      _createVNode(Tooltip, {
                        content: _ctx.$t("famikeep200.All locations")
                      }, null, 8, ["content"])
                    ], 2)
                  ]),
                  (locationsList.value && locationsList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        _createElementVNode("div", {
                          class: "leftMaps",
                          style: _normalizeStyle(mapStyleObj.value)
                        }, [
                          _createVNode(mapBox, {
                            lcoationMap: lcoationMap.value,
                            class: "mapBoxClass",
                            styleString: mapStyleObj.value,
                            functionPage: 'home'
                          }, null, 8, ["lcoationMap", "styleString"])
                        ], 4),
                        _createElementVNode("div", _hoisted_85, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationsList.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "infoItem pointer",
                              key: index
                            }, [
                              (index == 0)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_86))
                                : (_openBlock(), _createElementBlock("img", _hoisted_87)),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("div", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, [
                                    _createVNode(Tooltip, {
                                      content: item.detail ? item.detail : '--'
                                    }, null, 8, ["content"])
                                  ]),
                                  (item.is_virtual)
                                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                        key: 0,
                                        "popper-class": "custom-tooltip",
                                        content: _ctx.$t('famikeep200.When obtaining this location'),
                                        placement: "bottom-start"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_91
                                        ]),
                                        _: 1
                                      }, 8, ["content"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  (isVibe.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_92, [
                                        _createVNode(Tooltip, {
                                          content: _unref(dateFormatAm)(item.date, "YYYY-MM-DD HH:mm:ss")
                                        }, null, 8, ["content"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_93, [
                                        _createVNode(Tooltip, {
                                          content: _unref(dateFormat)(item.date, "YYYY-MM-DD HH:mm:ss")
                                        }, null, 8, ["content"])
                                      ]))
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_94, [
                        _hoisted_95,
                        _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_97, [
                  (showLocationLoading.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_skeleton, {
                          style: {"--el-skeleton-circle-size":"100px","width":"70%"},
                          animated: true,
                          count: "1",
                          loading: showLocationLoading.value
                        }, {
                          template: _withCtx(() => [
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("div", _hoisted_99, [
                                _createElementVNode("div", _hoisted_100, [
                                  _createVNode(_component_el_skeleton_item, {
                                    variant: "text",
                                    style: {"width":"100%","height":"350px"}
                                  })
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["loading"]),
                        _createVNode(_component_el_skeleton, {
                          style: {"--el-skeleton-circle-size":"40px","width":"30%"},
                          animated: true,
                          count: 5,
                          loading: showLocationLoading.value
                        }, {
                          template: _withCtx(() => [
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("div", _hoisted_103, [
                                  _createVNode(_component_el_skeleton_item, {
                                    variant: "text",
                                    style: {"width":"100%"}
                                  })
                                ]),
                                _createVNode(_component_el_skeleton_item, {
                                  variant: "text",
                                  style: {"width":"50%"}
                                }),
                                _createVNode(_component_el_skeleton_item, {
                                  variant: "text",
                                  style: {"width":"50%"}
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ], 64))
                    : _createCommentVNode("", true)
                ])),
            _createElementVNode("div", _hoisted_104, [
              (showUseTimeLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                    _createElementVNode("template", null, [
                      _createVNode(_component_el_skeleton, {
                        style: {"width":"380px"},
                        loading: showUseTimeLoading.value,
                        animated: "",
                        count: 7
                      }, {
                        template: _withCtx(() => [
                          _createElementVNode("div", _hoisted_106, [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"5%"}
                            }),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"margin-left":"16px","width":"90%"}
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_107, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["title", lang.value == 'ar' ? 'reverse' : ''])
                    }, [
                      _createVNode(Tooltip, {
                        content: _ctx.$t("famikeep200.Weekly average usage time")
                      }, null, 8, ["content"])
                    ], 2),
                    (daliyTime.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("div", _hoisted_110, _toDisplayString(daliyTime.value), 1),
                            _createElementVNode("div", _hoisted_111, [
                              _createElementVNode("div", {
                                class: _normalizeClass(useProportion.value > 0 ? 'changeRed' : 'changeGreen')
                              }, [
                                (useProportion.value > 0)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_112))
                                  : (_openBlock(), _createElementBlock("img", _hoisted_113)),
                                _createTextVNode(" " + _toDisplayString(Math.abs(useProportion.value)) + "% ", 1)
                              ], 2),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("famikeep200.Floating comparison with last week")), 1)
                            ])
                          ]),
                          _hoisted_114
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_115, [
                          _hoisted_116,
                          _createElementVNode("div", _hoisted_117, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                        ]))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", _hoisted_119, [
                _createVNode(Tooltip, {
                  content: _ctx.$t("famikeep200.Most used applications")
                }, null, 8, ["content"])
              ]),
              (!mostUseLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                    (appUseList.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appUseList.value, (item, index) => {
                            return (_openBlock(), _createBlock(appItem, {
                              class: "perc",
                              key: index,
                              item: item
                            }, null, 8, ["item"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_122, [
                          _hoisted_123,
                          _createElementVNode("div", _hoisted_124, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                        ]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_125, [
                    _createElementVNode("template", null, [
                      _createVNode(_component_el_skeleton, {
                        style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                        loading: mostUseLoading.value,
                        animated: true,
                        count: 5
                      }, {
                        template: _withCtx(() => [
                          _createElementVNode("div", _hoisted_126, [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "circle",
                              style: {"margin-right":"12px"}
                            }),
                            _createElementVNode("div", _hoisted_127, [
                              _createElementVNode("div", _hoisted_128, [
                                _createVNode(_component_el_skeleton_item, {
                                  variant: "text",
                                  style: {"width":"20%"}
                                }),
                                _createVNode(_component_el_skeleton_item, {
                                  variant: "text",
                                  style: {"width":"10%"}
                                })
                              ]),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"85%"}
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["leftcontent instagram", loading.value ? 'm-t-0' : ''])
            }, [
              _createElementVNode("div", _hoisted_129, [
                _hoisted_130,
                _createElementVNode("span", _hoisted_131, [
                  _createVNode(Tooltip, {
                    content: _ctx.$t("leftTab.instagram")
                  }, null, 8, ["content"])
                ])
              ]),
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("div", {
                  class: _normalizeClass(["title", lang.value == 'ar' ? 'reverse' : ''])
                }, _toDisplayString(_ctx.$t("dashboard.insContact")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["jump", lang.value == 'ar' ? 'reverse' : '']),
                  onClick: jumpToInsContact
                }, _toDisplayString(_ctx.$t("dashboard.view")), 3)
              ]),
              (loading.value)
                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                    key: 0,
                    style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                    loading: loading.value,
                    animated: true,
                    count: 5
                  }, {
                    template: _withCtx(() => [
                      _createElementVNode("div", _hoisted_133, [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "circle",
                          style: {"margin-right":"12px"}
                        }),
                        _createElementVNode("div", _hoisted_134, [
                          _createElementVNode("div", _hoisted_135, [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"20%"}
                            }),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"10%"}
                            })
                          ]),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"20%"}
                          }),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"85%"}
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(ins_session) && _unref(ins_session).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ins_session), (item, index) => {
                            return (_openBlock(), _createBlock(numberItem, {
                              key: index,
                              item: item,
                              host: `instagram`
                            }, null, 8, ["item"]))
                          }), 128))
                        ]))
                      : (!loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                            _hoisted_138,
                            _createElementVNode("div", _hoisted_139, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ], 64))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["rightcontent whatsapp", loading.value ? 'm-t-0' : ''])
            }, [
              _createElementVNode("div", _hoisted_140, [
                _hoisted_141,
                _createElementVNode("span", _hoisted_142, _toDisplayString(_ctx.$t("leftTab.whatsapp")), 1)
              ]),
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("div", {
                  class: _normalizeClass(["title", lang.value == 'ar' ? 'reverse' : ''])
                }, _toDisplayString(_ctx.$t("dashboard.contact")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["jump", lang.value == 'ar' ? 'reverse' : '']),
                  onClick: jumpToContact
                }, _toDisplayString(_ctx.$t("dashboard.view")), 3)
              ]),
              (loading.value)
                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                    key: 0,
                    style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                    loading: loading.value,
                    animated: true,
                    count: 5
                  }, {
                    template: _withCtx(() => [
                      _createElementVNode("div", _hoisted_144, [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "circle",
                          style: {"margin-right":"12px"}
                        }),
                        _createElementVNode("div", _hoisted_145, [
                          _createElementVNode("div", _hoisted_146, [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"20%"}
                            }),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"10%"}
                            })
                          ]),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"20%"}
                          }),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"85%"}
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(active_session) && _unref(active_session).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(active_session), (item, index) => {
                            return (_openBlock(), _createBlock(numberItem, {
                              key: index,
                              item: item
                            }, null, 8, ["item"]))
                          }), 128))
                        ]))
                      : (!loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                            _hoisted_149,
                            _createElementVNode("div", _hoisted_150, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ], 64))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["device account", lang.value == 'ar' ? 'reverse' : '']),
              style: {"padding":"20px 0 0 0"}
            }, [
              _createElementVNode("div", _hoisted_151, [
                _createElementVNode("span", _hoisted_152, [
                  _createVNode(Tooltip, {
                    content: _ctx.$t("dashboard.target")
                  }, null, 8, ["content"])
                ]),
                _withDirectives(_createElementVNode("img", {
                  src: _imports_6,
                  onClick: toUnbind,
                  style: {"cursor":"pointer"}
                }, null, 512), [
                  [_directive_click_outside, handleClickOutside]
                ])
              ]),
              (loading.value)
                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                    key: 0,
                    style: {"width":"100%"},
                    loading: loading.value,
                    animated: "",
                    count: 8
                  }, {
                    template: _withCtx(() => [
                      _createElementVNode("div", _hoisted_153, [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"15%"}
                        }),
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"margin-left":"16px","width":"80%"}
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(isVibe.value ? 'demoStyle' : '')
                    }, [
                      (showUnbind.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["unbinding", lang.value == 'ar' ? 'changePlace' : '']),
                            onClick: unbindDevice,
                            id: "showDiv"
                          }, [
                            _hoisted_154,
                            _createElementVNode("span", _hoisted_155, _toDisplayString(_ctx.$t("pop.unbindTitle")), 1)
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_156, [
                      _createElementVNode("img", {
                        src: _unref(Launcher),
                        alt: ""
                      }, null, 8, _hoisted_157),
                      _createElementVNode("div", {
                        class: _normalizeClass(["dexText", lang.value == 'ar' ? 'changePadding' : ''])
                      }, [
                        _withDirectives((_openBlock(), _createElementBlock("span", {
                          class: "deviceName homeOverflow",
                          onClick: changeDevice
                        }, [
                          _createVNode(Tooltip, {
                            content: currentDevice.value,
                            class: "modelStyle"
                          }, null, 8, ["content"])
                        ])), [
                          [_directive_click_outside, handleClickIosList]
                        ]),
                        (showIosList.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iosList.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "singleItem",
                                  key: index,
                                  onClick: ($event: any) => (changeDeviceModel(index))
                                }, [
                                  _createElementVNode("img", {
                                    class: _normalizeClass(["checked", item.id == currentDeviceId.value ? 'oneOpacity' : 'zeroOpacity']),
                                    alt: "",
                                    src: _imports_9
                                  }, null, 2),
                                  _createElementVNode("div", _hoisted_160, [
                                    _createElementVNode("div", _hoisted_161, [
                                      _createVNode(Tooltip, {
                                        content: item.name
                                      }, null, 8, ["content"])
                                    ]),
                                    _createElementVNode("div", _hoisted_162, [
                                      _hoisted_163,
                                      _createVNode(Tooltip, {
                                        content: item.model
                                      }, null, 8, ["content"])
                                    ])
                                  ])
                                ], 8, _hoisted_159))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_164, [
                          _createVNode(Tooltip, { content: currentDeviceModel.value }, null, 8, ["content"])
                        ]),
                        (showRebound.value)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "reboundText",
                              onClick: toRebound
                            }, [
                              _createVNode(Tooltip, {
                                content: _ctx.$t("pop.changeBound")
                              }, null, 8, ["content"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_165, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(targetDevice), (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item,
                          class: "tgDevice"
                        }, [
                          _createElementVNode("div", _hoisted_166, [
                            _createElementVNode("div", _hoisted_167, [
                              _createElementVNode("img", {
                                src: item.src
                              }, null, 8, _hoisted_168)
                            ]),
                            _createElementVNode("div", _hoisted_169, [
                              _createElementVNode("span", _hoisted_170, [
                                _createVNode(Tooltip, {
                                  content: item.text
                                }, null, 8, ["content"])
                              ]),
                              (item.data)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_171, _toDisplayString(item.content ? _unref(dateFormat)(item.content, "YYYY-MM-DD HH:mm") : ""), 1))
                                : (item.battery)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_172, _toDisplayString(item.content ? item.content + "%" : "--"), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_173, _toDisplayString(item.content ? item.content : "--"), 1))
                            ])
                          ]),
                          (item.data)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "syncBtn",
                                onClick: handleUpdateClick
                              }, [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  class: _normalizeClass(["updateIcon", syncLoading.value ? 'loading' : '']),
                                  alt: ""
                                }, null, 2),
                                _createElementVNode("span", _hoisted_174, [
                                  _createVNode(Tooltip, {
                                    content: _ctx.$t("chat.sync")
                                  }, null, 8, ["content"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ], 64))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["account rightAccount", lang.value == 'ar' ? 'reverse' : '']),
              id: "account",
              style: _normalizeStyle(deviceInfo.value.length > 1 ? 'padding: 15px 0 15px 0' : 'padding: 20px 0;')
            }, [
              _createElementVNode("div", _hoisted_175, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("dashboard.account")), 1)
              ]),
              _createVNode(_component_el_skeleton, {
                style: {"width":"80%"},
                loading: loading.value,
                animated: "",
                count: 4
              }, {
                template: _withCtx(() => [
                  _createElementVNode("div", _hoisted_176, [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "text",
                      style: {"width":"30%"}
                    }),
                    _createVNode(_component_el_skeleton_item, {
                      variant: "text",
                      style: {"margin-left":"16px"}
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_177, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(account), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["one", [item.singular ? 'zebra' : '']]),
                        key: index
                      }, [
                        _createElementVNode("img", {
                          src: item.src,
                          style: {"padding-right":"10px"}
                        }, null, 8, _hoisted_178),
                        (item.isBind)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              content: _unref(bindDevice),
                              placement: "bottom",
                              disabled: _unref(isDisabled),
                              "show-after": 200,
                              "popper-class": "myTooltip"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["text", [index == 2 ? 'boundedDevice' : '']]),
                                  onMouseenter: isShowTooltip
                                }, [
                                  _createTextVNode(_toDisplayString(item.text) + " ", 1),
                                  (item.data)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_179, _toDisplayString(item.content
                          ? _unref(dateFormat)(item.content, "YYYY-MM-DD HH:mm")
                          : ""), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_180, _toDisplayString(item.content ?
                          item.content : '--'), 1))
                                ], 34)
                              ]),
                              _: 2
                            }, 1032, ["content", "disabled"]))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["text", index == 2 ? 'boundedDevice' : ''])
                            }, [
                              _createTextVNode(_toDisplayString(item.text) + " ", 1),
                              (item.data)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_181, _toDisplayString(item.content
                        ? _unref(dateFormat)(item.content, "YYYY-MM-DD HH:mm")
                        : ""), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_182, _toDisplayString(item.content ?
                        item.content : '--'), 1))
                            ], 2))
                      ], 2))
                    }), 128)),
                    (!autoRenew.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "renew",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (goPay('btn')))
                        }, [
                          _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.$t("dashboard.renew")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ], 6)
          ]))
    ]),
    (deviceType.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
          _createElementVNode("div", _hoisted_185, [
            _createElementVNode("div", {
              class: _normalizeClass(["title", lang.value == 'ar' ? 'reverse' : ''])
            }, [
              _createVNode(Tooltip, {
                content: _ctx.$t("famikeep200.Photos")
              }, null, 8, ["content"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["jump", lang.value == 'ar' ? 'reverse' : '']),
              onClick: jumpToPhoto
            }, [
              _createVNode(Tooltip, {
                content: _ctx.$t("dashboard.view")
              }, null, 8, ["content"])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_186, [
            _createElementVNode("div", _hoisted_187, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photoListArray.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["photoItem", _unref(userAgent).includes('OPR') ? 'operaStyle' : '']),
                  key: index
                }, [
                  _createElementVNode("img", {
                    class: "itemPhoto",
                    src: item.thumb_url ? item.thumb_url : item.origin_url
                  }, null, 8, _hoisted_188)
                ], 2))
              }), 128))
            ]),
            (!photoListArray.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                    return _createElementVNode("div", {
                      class: _normalizeClass(["emptyPhoto", _unref(userAgent).includes('OPR') ? 'operaStyle' : '']),
                      key: index
                    }, _hoisted_191, 2)
                  }), 64))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (showUnbindDialog.value)
      ? (_openBlock(), _createBlock(noticeDialog, {
          key: 6,
          visible: showUnbindDialog.value,
          user: true,
          title: _ctx.$t('pop.unbindTitle'),
          width: 480,
          info: `${_ctx.$t('pop.unbindText1')} ${deviceType.value ? currentAppleId.value : currentDevice.value} ${_ctx.$t(
      'pop.unbindText2'
    )}`,
          onConfirm: closeDialog,
          onCancle: confirmUnbind,
          onUnbindCancle: closeDialog,
          Cancel: _ctx.$t('pop.yes'),
          Okay: _ctx.$t('pop.no')
        }, null, 8, ["visible", "title", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (showReboundDialog.value)
      ? (_openBlock(), _createBlock(noticeDialog, {
          key: 7,
          visible: showReboundDialog.value,
          title: _ctx.$t('pop.changeBound'),
          width: 480,
          info: `${_ctx.$t('pop.reboundText1')} ${deviceType.value ? currentAppleId.value : currentDevice.value} ${_ctx.$t(
      'pop.reboundText4'
    )}`,
          onConfirm: confirmRebind,
          onCancle: closeReboundDialog,
          Cancel: _ctx.$t('pop.no'),
          Okay: _ctx.$t('pop.yes')
        }, null, 8, ["visible", "title", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (showRebounding.value)
      ? (_openBlock(), _createBlock(noticeDialog, {
          key: 8,
          visible: showRebounding.value,
          title: _ctx.$t('pop.rebounding'),
          width: 480,
          showclose: false,
          showBtn: false
        }, {
          img: _withCtx(() => [
            _createElementVNode("div", _hoisted_192, [
              _createElementVNode("div", _hoisted_193, _toDisplayString(_unref(percent)) + "%", 1),
              _hoisted_194
            ])
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    (showReboundFailed.value)
      ? (_openBlock(), _createBlock(noticeDialog, {
          key: 9,
          visible: showReboundFailed.value,
          title: _ctx.$t('pop.changeBound'),
          width: 480,
          info: `${_ctx.$t('pop.reboundFail1')} ${deviceType.value ? currentAppleId.value : currentDevice.value} ${_ctx.$t(
      'pop.reboundFail2'
    )}`,
          onConfirm: confirmRebind,
          onCancle: closeReboundFailed,
          Cancel: _ctx.$t('pop.cancel'),
          Okay: _ctx.$t('pop.tryAgain')
        }, null, 8, ["visible", "title", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (showNoLocation.value)
      ? (_openBlock(), _createBlock(noticeDialog, {
          key: 10,
          visible: showNoLocation.value,
          title: _ctx.$t('pop.changeBound'),
          width: 480,
          info: _ctx.$t('pop.noRebound'),
          onConfirm: _cache[4] || (_cache[4] = ($event: any) => (goPay('pop'))),
          onCancle: closeNoLocation,
          Okay: _ctx.$t('pop.goPay'),
          Cancel: _ctx.$t('pop.cancel')
        }, null, 8, ["visible", "title", "info", "Okay", "Cancel"]))
      : _createCommentVNode("", true)
  ]))
}
}

})